import {useMutation} from "@tanstack/react-query";
import {createInvBarcode} from "../../../../../api/inventory/InvApi";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";

export const useCreateInventoryBarcode = () => {
    const {handleModal} = useModal();

    const {mutate, mutateAsync} = useMutation({
        mutationFn: () => createInvBarcode(),
        onSuccess: () => {
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate, mutateAsync};
};
